import Vue from 'vue'
import Vuex from 'vuex'
import VuexORM from '@vuex-orm/core'
import VuexORMAxios from '@vuex-orm/plugin-axios'
import axios from 'axios'

import { SnackbarProgrammatic as Snackbar } from 'buefy'
import labor from './modules/labor'
import mouse from './modules/mouse'
import ordering from './modules/ordering'

Vue.use(Vuex)

// axios Intercept requext
axios.interceptors.request.use(
    function (config) {
        //App.loadingOn()
        return config
    },
    function (error) {
        return Promise.reject(error)
    }
)
// axios Intercept response
axios.interceptors.response.use(
    function (response) {
        //App.loadingOff()
        return response
    },
    function (error) {
        //App.loadingOff()
        let status = error.response.status
        if (status == 500) {
            let message;
            if (Array.isArray(error.response.data)) {
                message = error.response.data[0];
            } else {
                message = error.response.data;
            }
            Snackbar.open({
                type: 'is-warning',
                position: 'is-top',
                message: message,
            })
        } else {
            Snackbar.open({
                type: 'is-warning',
                position: 'is-top',
                message: Vue.i18n.t(`errors.${status}`),
            })
        }
        return Promise.reject(error)
    }
)

// VuexORMAxios Headers Setting
VuexORM.use(VuexORMAxios, {
    axios,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
})

// Create a new instance of Database.
const database = new VuexORM.Database()
const models = require.context('@/models', true, /[A-Z]\w+\.js$/)
// Dynamically register the Model.
models.keys().forEach((filePath) => {
    const model = models(filePath)
    database.register(model.default)
})

// Create Vuex Store and register database through Vuex ORM.
const store = new Vuex.Store({
    namespaced: true,
    plugins: [VuexORM.install(database)],
    state() {
        return {
            disembarking: true,
        }
    },
    mutations: {
        toggleDisembarking(state) {
            state.disembarking = !state.disembarking
        },
    },
    modules: {
        labor,
        mouse,
        ordering,
    },
})

export default store
